import config from 'config';
import { MULESOFT_ORGANIZATION_LINK_ID } from '~/utils/navigation/constants';
import {
  DEFAULT_SORT,
  FEATURED_SORT,
  SIDEBAR_CONSISTENCY_DEFAULT_SORT
} from './constants';

const shouldHaveFeaturedSort = ({
  isANGSidebarConsistencyEnabled,
  isAuthenticated,
  show
}) => {
  if (!isANGSidebarConsistencyEnabled) {
    return false;
  }

  const showFeaturedOnPrivateExchange = show === MULESOFT_ORGANIZATION_LINK_ID;
  const showFeaturedOnGlobalExchange =
    !show ||
    config.presetLinks.find(({ id: presetShow }) => presetShow === show);

  return isAuthenticated
    ? showFeaturedOnPrivateExchange
    : showFeaturedOnGlobalExchange;
};

const shouldHaveRelevanceSort = ({
  isANGSidebarConsistencyEnabled,
  search
}) => {
  if (!isANGSidebarConsistencyEnabled) {
    return true;
  }

  return search;
};

export const getSortingOptions = ({
  isANGSidebarConsistencyEnabled,
  isAuthenticated,
  show,
  search
} = {}) => {
  const hasRelevanceSort = shouldHaveRelevanceSort({
    isANGSidebarConsistencyEnabled,
    search
  });

  const hasFeaturedSort = shouldHaveFeaturedSort({
    isANGSidebarConsistencyEnabled,
    isAuthenticated,
    show
  });

  const sortingOptions = {
    ...(hasRelevanceSort && {
      score: {
        label: 'Relevance'
      }
    }),
    ...(hasFeaturedSort && {
      featured: {
        label: 'Featured',
        fields: [
          {
            angField: 'assets.AssetNode.ranking',
            order: 'asc'
          },
          {
            angField: 'asset-minor-versions.MinorVersionNode.updatedAt',
            order: 'desc'
          }
        ]
      }
    }),
    name: {
      label: 'Name',
      fields: [
        {
          angField: 'k:assets.AssetNode.name',
          order: 'asc'
        }
      ]
    },
    last: {
      label: 'Last modified',
      fields: [
        {
          angField: 'asset-minor-versions.MinorVersionNode.updatedAt',
          order: 'desc'
        }
      ]
    },
    rating: {
      label: 'Rating',
      fields: [
        {
          angField: 'asset-minor-versions.MinorVersionNode.averageRating',
          order: 'desc'
        }
      ]
    }
  };

  return sortingOptions;
};

export const getDefaultSort = ({
  isANGSidebarConsistencyEnabled = false,
  isAuthenticated,
  show
}) => {
  if (!isANGSidebarConsistencyEnabled) {
    return DEFAULT_SORT;
  }

  if (
    shouldHaveFeaturedSort({
      isANGSidebarConsistencyEnabled,
      isAuthenticated,
      show
    })
  ) {
    return FEATURED_SORT;
  }

  return SIDEBAR_CONSISTENCY_DEFAULT_SORT;
};
